import React, { useRef, useState, useCallback, useEffect } from "react";

import styles from "styles.module.css";

import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";

import "./styles.css";
import { useTranslation } from "react-i18next";

import Filter from "./Filter";
import { useInfoStore } from "store/error";
import { AuctionedVesselQuota } from "interface/auction";
import Page from "./Page";
import { AuctionFilter, getUserAuctionedDataApi } from "api/sales";

const pageSize = 60;
const topHeight = 430;
const AuctionedWeightPage = () => {
	const { t } = useTranslation();
	const gridRef = useRef<HTMLDivElement>(null);
	const checkItemsRef = useRef<HTMLDivElement>(null);
	const [pageHeight, setPageHeight] = useState(window.innerHeight);
	const [data, setData] = useState<AuctionedVesselQuota[]>([]);

	const { setError } = useInfoStore();
	const [filterOptions, setFilterOptions] = useState<AuctionFilter>({
		quotaYear: new Date().getFullYear(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	useEffect(() => {
		getUserAuctionedDataApi(filterOptions)
			.then((response) => {
				setData(response.data);
			})
			.catch(() => {
				// / setError(err);
			});
	}, [filterOptions]);
	useEffect(() => {
		const updateHeight = () => setPageHeight(window.innerHeight);
		window.addEventListener("resize", updateHeight);

		return () => window.removeEventListener("resize", updateHeight);
	}, []);

	const exportGridAsPDF = () => {
		if (pdfRef.current !== null) {
			pdfRef.current.save();
		}
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};
	const currentHeight = pageHeight - topHeight;
	return (
		<div className={`${styles.PageContainer} auctioned-weight-page`}>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("AuctionedQuotaWeight")}
				</legend>
			</div>

			<div ref={checkItemsRef}>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div>{t("AuctionedPageMessage")}</div>
			<div
				style={{
					marginTop: 30,
					height: currentHeight,
					overflowY: "auto",
					paddingRight: 20,
					paddingBottom: 20,
				}}
				ref={gridRef}
			>
				{data.map((item, index) => (
					<div key={index}>
						<div className="text-bold">{item.vesselDescription} </div>
						<Page spaceQuota={item.species} />
						<br /><br />
					</div>
				))}
				<div></div>
			</div>
		</div>
	);
};

export default AuctionedWeightPage;
